'use client'
import React from 'react'
import { User } from 'lucide-react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '~/components/ui/dropdown-menu'
import { Button } from '~/components/ui/button'
import { useMutation } from '@tanstack/react-query'
import authApi from '~/apis/auth'
import { useUser } from '~/provider/UserProvider'
import Link from 'next/link'
import { toast } from 'sonner'

const Account = () => {
    const [user, setUser] = useUser()
    const logout = useMutation({
        mutationFn: () => authApi.logout(),
        onSuccess: (data) => {
            toast.success(data.message)
            setUser(undefined)
        },
        onError: (err) => {
            toast.error(err.message)
        }
    })
    const handleLogout = () => {
        logout.mutate()
        authApi.logoutNext()
    }
    return (
        <>
            {user && (
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant={'ghost'} className='h-auto rounded-lg p-2'>
                            <User />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align='end' className='rounded-lg'>
                        <Link href={'/account'}>
                            <DropdownMenuItem className='cursor-pointer rounded-lg px-3'>Tài khoản</DropdownMenuItem>
                        </Link>
                        <DropdownMenuItem className='cursor-pointer rounded-lg px-3' onClick={handleLogout}>
                            Đăng xuất
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            )}
        </>
    )
}

export default Account
